import { render, staticRenderFns } from "./InsectCauseIcon.vue?vue&type=template&id=4d965b2d&"
import script from "./InsectCauseIcon.vue?vue&type=script&lang=js&"
export * from "./InsectCauseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d965b2d')) {
      api.createRecord('4d965b2d', component.options)
    } else {
      api.reload('4d965b2d', component.options)
    }
    module.hot.accept("./InsectCauseIcon.vue?vue&type=template&id=4d965b2d&", function () {
      api.rerender('4d965b2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/InsectCauseIcon.vue"
export default component.exports